import '../plugins/scroller.js';
import { lockScroll } from '../modules/lockScroll.js';

var scroll = {},
		mobSidebarProp = {
			busy: false,
			active: true
		}

var grid = {
	exists: false,
	heroExists: false,
	home: false,
	DOM: {
		$sitewide: null,
		$sitewideBeam: null,
		$bg: null,
		$logo: null,
		$sidebar: null,
		$heroTop: null,
		$heroBottom: null,
		$partners: null,
		$attention: null,
	},
	sitewide: {
		small: {
			start: null,
			is: false,
			changed: false,
			logo : {
				isSticky: false,
				isMoved: false,
				changed: false,
			}
		},
		beam: {
			start: 0,
			isMoving: false,
			changed: false,
		},
		hidden: {
			start: null,
			is: false,
			isAnimated: false,
			changed: false
		},
	},
	bg: {
		start: null,
		isMoved: false,
		timeout: null,
		changed: false
	},
	sidebar: {
		start: null,
		isActive: false,
		changed: false
	},
	attention: {
		start: null,
		exists: null,
		isActive: false,
		changed: false
	},
	hero: {
		procent: 100,
		translateY: 0,
		opacity: 1,
		changed: false
	}
}

grid.items = function() {
	if ($('#sitewide').length != '') {
		grid.exists = true;
		grid.DOM.$sitewide = $('#sitewide');
		grid.DOM.$logo = $('#sitewide .logo');
		grid.DOM.$bg = $('#background');
		grid.DOM.$sidebar = $('#sidebar');
		grid.DOM.$heroTop = $('#hero .hero-animate-top');
		grid.DOM.$heroBottom = $('#hero .hero-animate-bottom');
		if ($('body').hasClass('home')) {
			grid.home = true;
			grid.DOM.$partners = $('.block-logos');
		}
		if ($('#sitewide').hasClass('hero-exists')) {
			grid.heroExists = true;
			grid.DOM.$sitewideBeam = $('#sitewide-beam');
		}
		if ($('#attention-bar').length != '') {
			grid.attention.exists = true;
			grid.DOM.$attention = $('#attention-bar');
		}
		grid.resize();
	}
}

grid.resize = function() {
	if (grid.exists == true) {
		grid.sitewide.small.start = 10;
		grid.sitewide.beam.start = 10;
		grid.sitewide.hidden.start = 152;
		grid.sidebar.start = ($(window).height() * 0.33);
		if (Modernizr.mq('(min-width: 1024px)') && grid.home == true) {
			grid.sidebar.start = ($(window).height() * 1)
		}
		if (grid.sidebar.start >= $(document).height() - $(window).height()) {
			grid.sidebar.start = ($(document).height() - $(window).height()) * 0.5;
		}
		if (Modernizr.mq('(max-width: 767px)')) {
			grid.sitewide.small.start = 152;
			grid.sitewide.hidden.start = 152;
		}
		if ($('#sitewide').hasClass('hero-exists') && Modernizr.mq('(min-width: 1024px)')) {
			grid.sitewide.small.start = ($(window).height() * 1) - $('#sitewide').outerHeight(true);
			grid.sitewide.beam.start = ($(window).height() * 1) - $('#sitewide').outerHeight(true);
			grid.bg.start = ($(window).height() * 1)
		}
		if (grid.attention.exists == true) {
			if ($('#attention-bar .button').hasClass('is-sticky')) {
				grid.attention.start = 10;
			} else if ($('.block-sidebar-form').hasClass('is-become-a-friend')) {
				grid.attention.start = $(window).height() * 0.25;
			} else {
				grid.attention.start = ($(document).height() - $(window).height()) * 0.5;
			}
		}
	}
}

grid.calculation = function(pos) {
	if (grid.exists == true && lockScroll.stat == false) {
		// Sitewide small + logo
		if (Modernizr.mq('(max-width: 767px)')) {
			if (pos.direction == 'down' && pos.current.top >= grid.sitewide.small.start) {
				if (grid.sitewide.small.is != true) {
					grid.sitewide.small.is = true;
					grid.sitewide.small.changed = true;
				}
			} else if (pos.direction == 'up' && pos.current.top <= 64) {
				if (grid.sitewide.small.is != false) {
					grid.sitewide.small.is = false;
					grid.sitewide.small.changed = true;
				}
			}
			// logo
			if (pos.current.top >= 1 && pos.current.top <= 64) {
				if (grid.sitewide.small.logo.isSticky != true) {
					grid.sitewide.small.logo.isSticky = true;
					grid.sitewide.small.logo.changed = true;
				}
				if (grid.sitewide.small.logo.isMoved != false) {
					grid.sitewide.small.logo.isMoved = false;
					grid.sitewide.small.logo.changed = true;
				}
			} else if (pos.direction == 'up' && pos.current.top >= 64 && pos.current.top <= grid.sitewide.small.start) {
				// if (grid.sitewide.small.logo.isSticky != false) {
				// 	grid.sitewide.small.logo.isSticky = false;
				// 	grid.sitewide.small.logo.changed = true;
				// }
				// if (grid.sitewide.small.logo.isMoved != true) {
				// 	grid.sitewide.small.logo.isMoved = true;
				// 	grid.sitewide.small.logo.changed = true;
				// }
			} else if (pos.direction == 'down' && pos.current.top >= 64 && pos.current.top <= grid.sitewide.small.start) {
				if (grid.sitewide.small.logo.isSticky != false) {
					grid.sitewide.small.logo.isSticky = false;
					grid.sitewide.small.logo.changed = true;
				}
				if (grid.sitewide.small.logo.isMoved != true) {
					grid.sitewide.small.logo.isMoved = true;
					grid.sitewide.small.logo.changed = true;
				}
			} else {
				if (grid.sitewide.small.logo.isSticky != false) {
					grid.sitewide.small.logo.isSticky = false;
					grid.sitewide.small.logo.changed = true;
				}
				if (grid.sitewide.small.logo.isMoved != false) {
					grid.sitewide.small.logo.isMoved = false;
					grid.sitewide.small.logo.changed = true;
				}
			}
		} else {
			if ( pos.current.top <= grid.sitewide.small.start) {
				if (grid.sitewide.small.is != false) {
					grid.sitewide.small.is = false;
					grid.sitewide.small.changed = true;
				}
			} else {
				if (grid.sitewide.small.is != true) {
					grid.sitewide.small.is = true;
					grid.sitewide.small.changed = true;
				}
			}
			// logo
			if (grid.sitewide.small.logo.isSticky != false) {
				grid.sitewide.small.logo.isSticky = false;
				grid.sitewide.small.logo.changed = true;
			}
			if (grid.sitewide.small.logo.isMoved != false) {
				grid.sitewide.small.logo.isMoved = false;
				grid.sitewide.small.logo.changed = true;
			}
		}

		// Sitewide beam
		if (grid.heroExists == true && Modernizr.mq('(min-width: 1024px)')) {
			if (pos.current.top >= grid.sitewide.beam.start) {
				if (grid.sitewide.beam.isMoving != true) {
					grid.sitewide.beam.isMoving = true;
					grid.sitewide.beam.changed = true;
				}
			} else {
				if (grid.sitewide.beam.isMoving != false) {
					grid.sitewide.beam.isMoving = false;
					grid.sitewide.beam.changed = true;
				}
			}
		}

		// Sitewide hidden
		if (Modernizr.mq('(max-width: 767px)')) {
			if (pos.current.top >= grid.sitewide.hidden.start && pos.direction == 'down') {
				if (grid.sitewide.hidden.is != true) {
					grid.sitewide.hidden.is = true;
					grid.sitewide.hidden.changed = true;
				}
			}	else if (pos.direction == 'up' ) {
				if (grid.sitewide.hidden.is != false) {
					grid.sitewide.hidden.is = false;
					grid.sitewide.hidden.changed = true;
				}
			}
			if (grid.sitewide.hidden.changed == true) {
				if (pos.current.top >= grid.sitewide.hidden.start && grid.sitewide.small.changed == false) {
					if (grid.sitewide.hidden.isAnimated != true) {
						grid.sitewide.hidden.isAnimated = true;
					}
				} else {
					if (grid.sitewide.hidden.isAnimated != false) {
						grid.sitewide.hidden.isAnimated = false;
					}
				}
			}
		} else {
			if (grid.sitewide.hidden.is != false) {
				grid.sitewide.hidden.is = false;
				grid.sitewide.hidden.changed = true;
			}
		}

		// Background
		if (grid.heroExists == true && Modernizr.mq('(min-width: 1024px)')) {
			if (pos.current.top >= grid.bg.start) {
				if (grid.bg.isMoved != true) {
					grid.bg.isMoved = true;
					grid.bg.changed = true;
				}
			} else {
				if (grid.bg.isMoved != false) {
					grid.bg.isMoved = false;
					grid.bg.changed = true;
				}
			}
		}

		// Sidebar
		if (Modernizr.mq('(min-width: 1024px)')) {
			if (pos.current.top >= grid.sidebar.start) {
				if (grid.sidebar.isActive != true) {
					grid.sidebar.isActive = true;
					grid.sidebar.changed = true;
				}
			} else {
				if (grid.sidebar.isActive != false) {
					grid.sidebar.isActive = false;
					grid.sidebar.changed = true;
				}
			}
		}

		// attention
		if (grid.attention.exists == true && Modernizr.mq('(max-width: 1023px)')) {
			if (pos.current.top >= grid.attention.start) {
				if (grid.attention.isActive != true) {
					grid.attention.isActive = true;
					grid.attention.changed = true;
				}
			} else {
				if (grid.attention.isActive != false) {
					grid.attention.isActive = false;
					grid.attention.changed = true;
				}
			}
		}

		// Hero
		if (Modernizr.mq('(min-width: 1024px)')) {
			let procent = 100,
					opacity = 0,
					translateY = 0,
					translateY2 = 0,
					offset = $(window).height() * 0.75;
			if (pos.current.top <= offset) {
				procent = Math.round( pos.current.top / ( offset / 100) );
				opacity = 1 - (procent / 100);
				if (grid.home == true) {
					translateY = Math.round((offset / 100) * (procent * 0.33));
				} else {
					translateY = Math.round((offset / 100) * (procent * 0.1));
				}
				translateY2 = Math.round((offset / 100) * (procent * 0.75));
			} else {
				procent = 0;
				opacity = 0;
				if (grid.home == true) {
					translateY = Math.round((offset / 100) * (100 * 0.33));
				} else {
					translateY = Math.round((offset / 100) * (100 * 0.1));
				}
				translateY2 = Math.round((offset / 100) * (100 * 0.75));
			}
			if (grid.hero.procent != procent) {
				grid.hero = {
					procent: procent,
					translateY2: translateY2,
					translateY: translateY,
					opacity: opacity,
					changed: true,
				}
			}
		}

	}
}

grid.animation = function(pos) {
	if (grid.exists == true) {

		// Sitewide smaller
		if (grid.sitewide.small.changed == true) {
			grid.sitewide.small.changed = false;
			if (grid.sitewide.small.is == true) {
				grid.DOM.$sitewide.addClass('is-small').addClass('is-sticky');
				// $('#sidebar').removeClass('is-inactive');
			} else {
				grid.DOM.$sitewide.removeClass('is-small').removeClass('is-sticky');
				// $('#sidebar').addClass('is-inactive');
			}
		}

		// Sitwide logo mobiel
		if (grid.sitewide.small.logo.changed == true) {
			grid.sitewide.small.logo.changed = false;
			if (grid.sitewide.small.logo.isSticky == true) {
				grid.DOM.$logo.addClass('is-sticky');
			} else {
				grid.DOM.$logo.removeClass('is-sticky');
			}
			if (grid.sitewide.small.logo.isMoved == true) {
				grid.DOM.$logo.addClass('is-slow').addClass('is-moved');
			} else {
				grid.DOM.$logo.removeClass('is-slow').removeClass('is-moved');
			}
		}

		// Sitewide beam
		if (grid.sitewide.beam.changed == true) {
			grid.sitewide.beam.changed = false;
			if (grid.sitewide.beam.isMoving == true) {
				grid.DOM.$sitewideBeam.addClass('is-moving');
			} else {
				grid.DOM.$sitewideBeam.removeClass('is-moving');
			}
		}

		// Sitewide hidden
		if (grid.sitewide.hidden.changed == true) {
			grid.sitewide.hidden.changed = false;
			if (grid.sitewide.hidden.is == true) {
				grid.DOM.$sitewide.addClass('is-hidden');
			} else {
				grid.DOM.$sitewide.removeClass('is-hidden');
			}
			if (grid.sitewide.hidden.isAnimated == true) {
				grid.DOM.$sitewide.addClass('is-animated');
			} else {
				grid.DOM.$sitewide.removeClass('is-animated');
			}
		}

		// Background
		if (grid.bg.changed == true) {
			grid.bg.changed = false;
			if (grid.bg.isMoved == true) {
				grid.DOM.$bg.addClass('is-moved');
				clearTimeout(grid.bg.timeout);
				grid.bg.timeout = setTimeout(function() {
					if ($('#background .el-video.is-hero .youtube-video.active').length != '') {
						var $this = $('#background .el-video.is-hero .youtube-video.active');
						aSync.youtube.pause($this);
					}
				}, 3000);
			} else {
				clearTimeout(grid.bg.timeout);
				grid.DOM.$bg.removeClass('is-moved');
				if ($('#background .el-video.is-hero .youtube-video.active').length != '') {
					var $this = $('#background .el-video.is-hero .youtube-video.active');
					aSync.youtube.continue($this);
				}
			}
		}

		// Sidebar
		if (grid.sidebar.changed == true) {
			grid.sidebar.changed = false;
			if (grid.sidebar.isActive == true) {
				grid.DOM.$sidebar.addClass('is-active');
				if (grid.home == true) {
					grid.DOM.$partners.addClass('is-inactive');
				}
			} else {
				grid.DOM.$sidebar.removeClass('is-active');
				if (grid.home == true) {
					grid.DOM.$partners.removeClass('is-inactive');
				}
			}
		}

		// Attention
		if (grid.attention.changed == true) {
			grid.attention.changed = false;
			if (grid.attention.isActive == true) {
				grid.DOM.$attention.addClass('is-active');
			} else {
				grid.DOM.$attention.removeClass('is-active');
			}
		}

		// Hero
		if (grid.hero.changed == true) {
			grid.hero.changed = false;
			grid.DOM.$heroTop.css({'opacity' : grid.hero.opacity, transform: 'translateY(-'+grid.hero.translateY+'px)'});
			grid.DOM.$heroBottom.css({'opacity' : grid.hero.opacity, transform: 'translateY(-'+grid.hero.translateY2+'px)'});
		}

	}
}

scroll.init = function() {
	$(window).scroller({
		items : function() {
			grid.items();
		},
		calculation: function(pos) {
			grid.calculation(pos);
		},
		animation: function(pos) {
			grid.animation(pos);
		},
		resize: function() {
			grid.resize();
		},
	});
	$('.js-scroll-down').click(function(e) {
		e.preventDefault();
		let top = ($(window).height() * 0.75);
		$("html, body").animate({ scrollTop: top }, 800);
	});
	$('.js-open-sidebar').click(function(e) {
		e.preventDefault();
		if (mobSidebarProp.busy == false) {
			mobSidebarProp.busy = true;
			mobSidebarProp.active = true;
			$('#sidebar').addClass('is-open');
			setTimeout(function() {
				$('#sitewide, #sitewide-beam').addClass('is-inactive');
				lockScroll.init(true);
				mobSidebarProp.busy = false;
			}, 850);
		}
	});
	$('.js-close-sidebar').click(function(e) {
		e.preventDefault();
		if (mobSidebarProp.busy == false) {
			mobSidebarProp.busy = true;
			mobSidebarProp.active = false;
			$('#sitewide, #sitewide-beam').removeClass('is-inactive');
			$('#sidebar').removeClass('is-open');
			setTimeout(function() {
				lockScroll.init(false);
				mobSidebarProp.busy = false;
			}, 500);
		}
	});
}

scroll.resize = function(pos) {
	$(window).scroller.resize();
	if (Modernizr.mq('(min-width: 1024px)') && mobSidebarProp.active == true) {
		$('#sitewide, #sitewide-beam').removeClass('is-inactive');
		lockScroll.init(false);
	}
}

export { scroll };
